import { put, call } from 'redux-saga/effects';
import { fcmNotifiTokenSave, fcmNotificationSend, notificationsFetch, notificationRead, notificationsFetchDropDown, notificationsAllMarkAsRead } from '../services/fcmService'; 
import * as types from '../actions';

export function* fcmNotifiTokenSaveSaga(payload) {
  try {
    const response = yield call(fcmNotifiTokenSave, payload);
    yield put({ type: types.FCM_NOTIFI_TOKEN_SAVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.FCM_NOTIFI_TOKEN_SAVE_ERROR, error });
  }
}

export function* fcmNotificationSendSaga(payload) {
    try {
      const response = yield call(fcmNotificationSend, payload);
      yield put({ type: types.FCM_NOTIFICATION_SEND_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.FCM_NOTIFICATION_SEND_ERROR, error });
    }
}

export function* notificationsFetchSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER}); 
    const response = yield call(notificationsFetch, payload);
    yield put({ type: types.NOTIFICATIONS_FETCH_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.NOTIFICATIONS_FETCH_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* notificationReadSaga(payload) {
  try {
    const response = yield call(notificationRead, payload);
    yield put({ type: types.NOTIFICATION_READ_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.NOTIFICATION_READ_ERROR, error });
  }
}

export function* notificationsFetchDropDownSaga(payload) {
  try {
    const response = yield call(notificationsFetchDropDown, payload);
    yield put({ type: types.NOTIFICATIONS_FETCH_DROPDOWN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.NOTIFICATIONS_FETCH_DROPDOWN_ERROR, error });
  }
}

export function* notificationsAllMarkAsReadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER}); 
    const response = yield call(notificationsAllMarkAsRead, payload);
    yield put({ type: types.NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.NOTIFICATIONS_ALL_MARK_AS_READ_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

  